<template>
  <nav id="navbarBlur" class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    :class="[isRTL ? 'top-1 position-sticky z-index-sticky' : '']" v-bind="$attrs" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <!-- <breadcrumbs :current-directory="currentDirectory" :current-page="currentRouteName" :text-white="textWhite" /> -->
      <div class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none" :class="isRTL ? 'me-3' : ''">
        <a href="#" class="p-0 nav-link text-body" @click.prevent="minNav">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line" :class="textWhite ? 'bg-white' : ''"></i>
            <i class="sidenav-toggler-line" :class="textWhite ? 'bg-white' : ''"></i>
            <i class="sidenav-toggler-line" :class="textWhite ? 'bg-white' : ''"></i>
          </div>
        </a>
      </div>
       
      <div id="navbar" class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4 justify-content-end" :class="isRTL ? 'px-0' : 'me-sm-4'">
        <div class="pe-md-3 d-flex align-items-center ms-md-auto">

        </div>
        <ul class="navbar-nav justify-content-end">
          <LanguageSelector />
          <UserMenu :user-data="usuario" :customer="customer" />
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a id="iconNavbarSidenav" href="#" class="p-0 nav-link text-body" @click.prevent="minNav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <ChangePasswordModal />
</template>

<script>

  // import Breadcrumbs from "../Breadcrumbs.vue";
  import ChangePasswordModal from "@/components/ChangePasswordModal.vue";
  import LanguageSelector from "./components/LanguageSelector.vue";
  import UserMenu from "./components/UserMenu.vue";
  import { mapMutations, mapActions, mapState } from "vuex";

  export default {
    name: "Navbar",
    components: {
      // Breadcrumbs,
      ChangePasswordModal,
      LanguageSelector,
      UserMenu
    },
    props: {
      minNav: {
        type: Function,
        default: () => { },
      },
      textWhite: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        showMenu: false,
        usuario: null,
        showChangePassword: false,
        routeMapper: {
          "articulos": "artículos",
          "entradas-proveedor": "Entradas Proveedor",
          "envios": "envíos"
        }
      };
    },
    computed: {
      ...mapState(["isRTL"]),
      currentRouteName() {
        let paths = this.$route.path.split("/");

        if (paths.length > 2) {
          return this.$route.name;
        }
        return ""
      },
      currentDirectory() {
        let dir = this.$route.path.split("/")[1];
        let mapped = this.routeMapper[dir]
        if (mapped) {
          return mapped.charAt(0).toUpperCase() + mapped.slice(1);
        }
        return dir.charAt(0).toUpperCase() + dir.slice(1);
      },
      customer() {
        let user = JSON.parse(localStorage.getItem("user"));    
        if (!user || !('customer' in user) || !user['customer']) {
          return {name : ''};
        }
        return user['customer'];
      },
    },
    mounted() {
      this.usuario = JSON.parse(localStorage.getItem("user"));
    },
    created() {
      this.minNav;
    },
    methods: {
      ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
      ...mapActions(["toggleSidebarColor"]),

      toggleSidebar() {
        this.toggleSidebarColor("bg-white");
        this.navbarMinimize();
      }
    },
  };

</script>

<style>

  .dropstart .dropdown-menu[data-bs-popper] {
    top: 100% !important;
    right: 0 !important;
    margin-left: -14rem !important;
  }

  .align-sesion {
    height: 12px;
    margin-left: 5px;
  }

  .style-button-icon {
    margin-right: 22px;
    margin-left: 9px;
  }

  .transparent {
    background-color: transparent;
  }

  .btn-circle-icon:hover {
    background-color: #888888;
    color: whitesmoke
  }

  .btn-circle-icon {
    margin-left: 10px;
    color: #888888;
    border: 1px solid #888888;
    width: 38px;
    height: 38px;
    padding: 8px 9px;
    border-radius: 30px;
    text-align: center;
  }


  .align-sesion {
    height: 12px;
    margin-left: 5px;
  }

  .title-design {
    color: #5e6c84;
    font-size: 14px;
  }

  .divider-style {
    margin-bottom: 8px !important;
  }

</style>